module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"the-family\"-in-fullerton-california-dc9575256bd4ab2f48c8172a46f71a92.png";